import React from 'react'

const Loader = () => (
  <div className='loading-indicator-wrap'>
    <div className='loader' />
  </div>
)

export default Loader



// WEBPACK FOOTER //
// ./src/components/common/popups/Loader.js